import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Logo } from "@/components/brand/logo";
import { Button } from "@/components/ui/button";

interface MarketingNavbarProps {
  isAuthed: boolean;
}

export function MarketingNavbar({ isAuthed }: MarketingNavbarProps) {
  return (
    <header className="sticky top-0 z-30 border-b border-ink-200/60 bg-white/70 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 lg:px-12">
        <div className="flex items-center gap-3">
          <Logo tone="dark" size="md" to="/" />
          <span className="hidden rounded-full border border-ink-200/70 bg-white px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-ink-500 sm:inline">
            Beta
          </span>
        </div>

        <nav className="hidden items-center gap-8 md:flex">
          <Link
            to="/"
            className="text-[15px] font-medium text-ink-700 transition-colors hover:text-ink-900"
          >
            Ana Sayfa
          </Link>
          <Link
            to="/hakkimizda"
            className="text-[15px] font-medium text-ink-700 transition-colors hover:text-ink-900"
          >
            Hakkımızda
          </Link>
          <Link
            to="/fiyatlandirma"
            className="text-[15px] font-medium text-ink-700 transition-colors hover:text-ink-900"
          >
            Fiyatlandırma
          </Link>
          <Link
            to="/blog"
            className="text-[15px] font-medium text-ink-700 transition-colors hover:text-ink-900"
          >
            Blog
          </Link>
          <Link
            to="/contact"
            className="text-[15px] font-medium text-ink-700 transition-colors hover:text-ink-900"
          >
            İletişim
          </Link>
        </nav>

        <nav className="flex items-center gap-2">
          {isAuthed ? (
            <Button asChild className="h-10 gap-2 px-5 text-[15px]">
              <Link to="/dashboard">
                Uygulamaya Git
                <ArrowRight className="h-4 w-4" />
              </Link>
            </Button>
          ) : (
            <>
              <Button asChild className="h-10 gap-2 px-5 text-[15px]">
                <Link to="/register">
                  Hesap oluştur
                  <ArrowRight className="h-4 w-4" />
                </Link>
              </Button>
              <Button asChild variant="ghost" className="h-10 px-4 text-[15px]">
                <Link to="/login">Giriş yap</Link>
              </Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
